import { Component, OnDestroy, OnInit } from '@angular/core';
import { catchError, debounceTime, distinctUntilChanged, ignoreElements, Observable, of, Subscription } from 'rxjs';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { CompanyCesionarioDTO } from './interfaces/company-cesionario.interface';
import { CesionariosService } from '../service/cesionarios.service';
import { CesionarioQueryParam } from './interfaces/cesionario-viewmodel.interface';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-formula-view',
  templateUrl: './formula-view.component.html',
  styleUrls: ['./formula-view.component.scss']
})
export class FormulaViewComponent implements OnInit, OnDestroy {

  public pagedCesionarios$: Observable<PageResult<CompanyCesionarioDTO>>;
  public pagedCesionariosError$: Observable<any>;
  public cesionarioParams: CesionarioQueryParam;
  public filterForm: FormGroup;
  public searchSubs: Subscription;

  constructor(private cesionariosService: CesionariosService, private fb:FormBuilder) {
    this.pagedCesionarios$ = new Observable<PageResult<CompanyCesionarioDTO>>;
    this.cesionarioParams = {
      search: '',
      page: 1,
      pageSize: 10,
      sortColumn: '',
      sortOrder: ''
    };
    this.filterForm = this.fb.group({
      search: ''
    })
  }

  ngOnInit(): void {
    this.getCesionarios();
    this.searchSubs = this.filterForm.controls['search'].valueChanges
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((newVal) => {
      this.cesionarioParams = {
        ...this.cesionarioParams, search: newVal
      };
      this.getCesionarios();
    })
  }

  getCesionarios(): void {
    this.pagedCesionarios$ = this.cesionariosService.getCesionarios(this.cesionarioParams);
    this.pagedCesionariosError$ = this.pagedCesionarios$.pipe(
      ignoreElements(),
      catchError((err) => of(err))
    );
  }

  receiveChangePaginationCesionarios(pageChange: any){
    this.cesionarioParams = {
      ...this.cesionarioParams,
      page: pageChange.page,
      pageSize: pageChange.pageSize
    };
    this.getCesionarios();
  }

  receiveChangeSortingCesionarios(sortChange: any) {
    this.cesionarioParams = {
      ...this.cesionarioParams,
      sortColumn: sortChange.sortColumn,
      sortOrder: sortChange.sortOrder
    };
    this.getCesionarios();
  }

  ngOnDestroy(): void {
    this.searchSubs.unsubscribe();
  }

}
